import { Credentials, ICredentials } from '@aws-amplify/core';
import { Auth, Storage } from 'aws-amplify';

// LocalStack has no Cognito identity pool, so Amplify can't mint S3 credentials;
// its S3 accepts any key pair.
const LOCALSTACK_STORAGE_CREDENTIALS = {
  accessKeyId: 'test',
  secretAccessKey: 'test',
};

// Mirrors the stand-in the backend gives a local user (backend/lib/api/utils.go), so a key the
// browser writes under protected/<identityId>/ matches the identity id stored on the row.
const LOCAL_IDENTITY_REGION = 'us-east-1';

// No session token: LocalStack S3 accepts the bare key pair.
const getLocalStorageCredentials = async (): Promise<ICredentials> => {
  const session = await Auth.currentSession();
  const username = session.getIdToken().payload['cognito:username'];
  return {
    ...LOCALSTACK_STORAGE_CREDENTIALS,
    identityId: `${LOCAL_IDENTITY_REGION}:${username}`,
    authenticated: true,
  } as ICredentials;
};

type StorageConfig = Record<string, string>;

export const configureStorage = (storageConfig: StorageConfig) => {
  const { customEndpoint, ...config } = storageConfig;
  if (!customEndpoint) {
    Storage.configure(storageConfig);
    return;
  }

  // Auth.currentUserCredentials() goes through set(), which also needs an identity pool.
  Credentials.get = getLocalStorageCredentials;
  Credentials.set = getLocalStorageCredentials;
  Storage.configure({
    ...config,
    AWSS3: { customEndpoint, forcePathStyle: true },
  });
};
